import { useQuery, useMutation } from '@tanstack/react-query';
import { getTransactions, getManualTransactions, getCoinDetails, createDeposit, getInrHistory, transferVault, swapCoins, manualWithdrawal, getVaultData, getVaultDataLocal, transferVaultLocal, getUserBets, getBonusTypes } from '../api/walletApi';

export const useUserBetsQuery = (tab, subTab, uid, filters = {}) => {
  return useQuery({
    queryKey: ['userBets', tab, subTab, uid, filters],
    queryFn: () => getUserBets({ tab, subTab, uid, ...filters }),
    enabled: !!uid && !!tab,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
  });
};

export const useTransactionsQuery = (tab, uid, filters = {}) => {
  return useQuery({
    queryKey: ['transactions', tab, uid, filters],
    queryFn: () => getTransactions({ tab, uid, ...filters }),
    enabled: !!uid && !!tab,
    refetchOnWindowFocus: false,
  });
};

export const useBonusTypesQuery = (uid) => {
  return useQuery({
    queryKey: ['bonusTypes', uid],
    queryFn: () => getBonusTypes(uid),
    enabled: !!uid,
    refetchOnWindowFocus: false,
  });
};

export const useManualTransactionsQuery = (tab, uid, page) => {
  const req_type = tab === 'Deposit' ? 'deposit' : 'withdrawal';
  return useQuery({
    queryKey: ['manualTransactions', tab, uid, page],
    queryFn: () => getManualTransactions({ tab, uid, page, req_type }),
    enabled: !!uid && !!tab,
    refetchOnWindowFocus: false,
    keepPreviousData: true, // Keeps old data while fetching next page
  });
};

export const useCoinDetailsMutation = () => {
  return useMutation({
    mutationFn: getCoinDetails,
  });
};

export const useCreateDepositMutation = () => {
  return useMutation({
    mutationFn: createDeposit,
  });
};

export const useInrHistoryQuery = (name) => {
  return useQuery({
    queryKey: ['inrHistory', name],
    queryFn: () => getInrHistory(name),
    enabled: !!name,
    refetchOnWindowFocus: false,
  });
};

export const useTransferVaultMutation = () => {
  return useMutation({
    mutationFn: transferVault,
  });
};

export const useSwapCoinsMutation = () => {
  return useMutation({
    mutationFn: swapCoins,
  });
};

export const useManualWithdrawalMutation = () => {
  return useMutation({
    mutationFn: manualWithdrawal,
  });
};

export const useGetVaultDataMutation = () => {
  return useMutation({
    mutationFn: getVaultData,
  });
};

export const useGetVaultDataLocalMutation = () => {
  return useMutation({
    mutationFn: getVaultDataLocal,
  });
};

export const useTransferVaultLocalMutation = () => {
  return useMutation({
    mutationFn: transferVaultLocal,
  });
};
